import React from 'react'
import './timeline.css'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { Typography } from '@mui/material';

const CustomTimeline = ({icon, title, children}) => {
  return (
    <Timeline className='timeline'>
      <TimelineItem className='timeline-firstItem'>
        <TimelineSeparator>
          <TimelineDot className='timeline-dot-header'>
              {icon}
            </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent><Typography variant='h6' className='header-title'>{title}</Typography></TimelineContent>
      </TimelineItem>

    {children}
    </Timeline>
  )
}

export const CustomTimelineSeparator = ()=>{return(
    <TimelineSeparator className='separator'>
    <TimelineDot variant={'outlined'} className='timeline-dot'/>
    <TimelineConnector />
  </TimelineSeparator>
)
}

export default CustomTimeline